export default {
  metaData: state => state.metaData,
  matchesData: state => state.matchesData,
  resultsLoaded: state => state.resultsLoaded,
  filteredResults: state => state.filteredResults,
  utcDate: state => state.utcDate,
  resultsMap: state => state.resultsMap,
  translate: state => key => (state.translations ? state.translations[key] || key : key),
  companySettings: state => state.companySettings,
};
